import React from 'react';
import { connect } from 'react-redux';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { confirmCollectionDeletion } from '../actions';
import { collectionPermissions } from '../sharing/constants';

const CollectionTools = ({
  allowDelete,
  category,
  collection,
  listItem = false,
  showDelete,
  upward,
  url,
}) => (
  <StandardToolsMenu
    allowDelete={allowDelete}
    allowRead
    href={url}
    listItem={listItem}
    onDelete={() => showDelete(category, collection.code)}
    upward={upward}
  />
);

const mapStateToProps = ({
  auth: { role },
}, { collection }) => {
  const { collections } = role.permissions;
  return ({
    allowDelete: collections.destroy || collection.permissions[collectionPermissions.DESTROY],
  });
};

const mapDispatchToProps = {
  showDelete: confirmCollectionDeletion,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionTools);
